import React from 'react';
import { IIconProps, IconHeight, IconSizes, IconWidth } from './type';

const BadgeMadeInGermany: React.FC<IIconProps> = ({
  size = IconSizes.sm,
  UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={IconWidth[size]}
      height={IconHeight[size]}
      viewBox="0 0 16 17"
      fill="none"
      className={UNSAFE_className || ''}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.77059 1.62891C7.90654 1.52279 8.09346 1.52279 8.22941 1.62891L14.347 6.40442C14.4787 6.50719 14.5324 6.68613 14.4804 6.84863C14.4283 7.01114 14.2822 7.12074 14.1176 7.12074H13.4804V14.1514C13.4804 14.3711 13.3092 14.5493 13.098 14.5493H9.52941C9.31824 14.5493 9.14706 14.3711 9.14706 14.1514V10.835H6.85295V14.1514C6.85295 14.3711 6.68176 14.5493 6.47059 14.5493H2.90198C2.69081 14.5493 2.51963 14.3711 2.51963 14.1514V7.12074H1.88238C1.7178 7.12074 1.57169 7.01114 1.51965 6.84863C1.4676 6.68613 1.5213 6.50719 1.65297 6.40442L7.77059 1.62891ZM3.00914 6.34067C3.16815 6.38889 3.28433 6.54172 3.28433 6.72279V13.7534H6.08824V10.4371C6.08824 10.2173 6.25943 10.0391 6.47059 10.0391H9.52941C9.74057 10.0391 9.91176 10.2173 9.91176 10.4371V13.7534H12.7157V6.72279C12.7157 6.54172 12.8319 6.38889 12.9909 6.34067L8 2.44472L3.00914 6.34067Z"
        fill="black"
      />
    </svg>
  );
};

export default BadgeMadeInGermany;
